import Lookup from 'src/componentes/select2';

const StatusReuniao = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusReuniaoLookup"
      {...props}
    />
  );
};

export default StatusReuniao;
